import {Component} from 'substance'
import {PopoverComponent} from './popover/PopoverComponent'

class DWTopbar extends Component {

    constructor(...args) {
        super(...args)

        // this.context.api.events.on('__barcomponent', Event.DOCUMENT_INVALIDATED, () => {
        //     this.extendState({barStateValid: false})
        // })
    }

    //
    // dispose() {
    //     super.dispose()
    //     this.context.api.events.off('__barcomponent', Event.DOCUMENT_INVALIDATED)
    // }

    getInitialState() {
        return {barStateValid: true}
    }

    render($$) {
        const {topBarComponents = []} = this.props

        const leftRibbon = $$('div').ref('bar_left_ribbon')
        const rightRibbon = $$('div').ref('bar_right_ribbon')

        topBarComponents.forEach(topBarComponent => {
            let el
            if (topBarComponent.type === 'popover') {
                el = this.renderPopover($$, topBarComponent)
            } else if (topBarComponent.type === 'component') {
                el = $$(topBarComponent.component, {
                    /* TODO: @deprecated use statehandler to see if article is saving when its available */
                    isSaving: false
                })
            }

            if (topBarComponent.align === 'left') {
                leftRibbon.append(el)
            } else {
                rightRibbon.append(el)
            }
        })

        const barDiv = $$('div')
            .ref('bar_container')
            .append([
                leftRibbon,
                rightRibbon
            ])

        barDiv.addClass('sc-np-bar')

        if (this.context.api.hasLocalConfiguration()) {
            barDiv.addClass('barStateInvalid')
        }

        if (!this.state.barStateValid) {
            leftRibbon
                .append($$('div')
                    .addClass('invalidTextBlock')
                    .append(
                        this.getLabel('Article is invalid')
                    )
                )
            barDiv.addClass('barStateInvalid')
        }

        return barDiv
    }

    renderPopover($$, popover) {
        const id = popover.id
        return $$(PopoverComponent, {
            popover: popover,
            /* TODO: @deprecated use statehandler to see if article is saving when its available */
            isSaving: false
        }).ref('bar_popover_' + id)
    }
}

export {DWTopbar}
